import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import apiService from '../../services/apiServices';


// Async Thunks for API calls
export const fetchEmployees = createAsyncThunk('employees/fetchEmployees', async () => {
  const response = await apiService.get('employees');
  return response.data;
});

// Async Thunk for getting employee by ID
export const getEmployeeById = createAsyncThunk('employees/getEmployeeById', async (id) => {
  const response = await apiService.get(`employees/${id}`);
  return response.data;
});

export const addEmployee = createAsyncThunk('employees/addEmployee', async (employeeData) => {
  const response = await apiService.post('employees', employeeData);
  return response.data;
});

export const updateEmployee = createAsyncThunk('employees/updateEmployee', async (employeeData) => {
 
  console.log("updateEmployee")
  const response = await apiService.put(`employees/${employeeData._id}`, employeeData);
  console.log("updateEmployee", response)
  
  return response.data;
});

export const deleteEmployee = createAsyncThunk('employees/deleteEmployee', async (id) => {
  const response = await apiService.delete(`employees/${id}`);
  return id;
});

// Employee slice
const employeeSlice = createSlice({
  name: 'employees',
  initialState: {
    employees: [],
    employee: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
    .addCase(getEmployeeById.pending, (state) => {
      state.loading = true;
    })
    .addCase(getEmployeeById.fulfilled, (state, action) => {
      state.loading = false;
      state.employee = action.payload;
    })
    .addCase(getEmployeeById.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    })
      .addCase(fetchEmployees.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchEmployees.fulfilled, (state, action) => {
        state.loading = false;
        state.employees = action.payload;
      })
      .addCase(fetchEmployees.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(addEmployee.fulfilled, (state, action) => {
        state.employees.push(action.payload);
      })
      .addCase(updateEmployee.fulfilled, (state, action) => {
        const index = state.employees.findIndex(emp => emp._id === action.payload._id);
        if (index >= 0) {
          state.employees[index] = action.payload;
        }
      });
  },
});

export default employeeSlice.reducer;
